import { Input, Skeleton } from "@mui/material";
import React from "react";
import { IMaskInput } from "react-imask";
export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches;
  }
  return false;
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
  return false;
}
export const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
export const formatDate = (dateString) => {
  const date = new Date(
    dateString?.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
  );

  return (
    date
      .toLocaleString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(":", ":") + " PM"
  );
};
export const formatDateOnly = (dateString) => {
  const date = new Date(
    dateString?.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
  );

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getQueryParam(prop) {
  var params = {};
  var search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf("?") + 1)
  );
  var definitions = search.split("&");
  definitions.forEach(function (val, key) {
    var parts = val.split("=", 2);
    params[parts[0]] = parts[1];
  });
  return prop && prop in params ? params[prop] : params;
}
export const TextMaskCustom = React.forwardRef(function TextMaskCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      className="form-control"
      mask="(#00) 000-0000"
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});
export const TextMaskCustomForSSN = React.forwardRef(function TextMaskCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      className="form-control"
      mask="(#00) 000-0000"
      definitions={{
        "#": /[1-8]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});


export const formatDate2 = (dateString) => {
  const date = new Date(dateString);
  const options = { day: "numeric", month: "long", year: "numeric" };

  let formattedDate = date.toLocaleDateString("en-GB", options);

  // Add suffix to the day
  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  return formattedDate.replace(/\d+/, `${day}${suffix}`);
};
export const isHTMLContent = (str) => {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(
    (node) => node.nodeType === 1 // 1 means it's an element
  );
};
export function formatFileSize(sizeInBytes) {
  if (!sizeInBytes || isNaN(sizeInBytes)) return "0 KB";

  const sizeInKB = sizeInBytes / 1024;

  if (sizeInKB >= 1000) {
    const sizeInMB = sizeInKB / 1024;
    return `${sizeInMB.toFixed(2)} MB`;
  } else {
    return `${sizeInKB.toFixed(2)} KB`;
  }
}
export const formatTwoDigitDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const formatToMMDDYYYY = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr?.split("-");
  return `${month}/${day}/${year}`;
};
export const toggleAside = () => {
  const body = document.getElementById("kt_body");
  if (body) {
    body.classList.toggle("aside-show");
    body.classList.remove("topbar-enabled");
  }
};

export const toggleTopbar = () => {
  const body = document.getElementById("kt_body");
  if (body) {
    body.classList.toggle("topbar-enabled");
    body.classList.remove("aside-show");
  }
};
export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\D/g, "");
};
export const convertExcelDate = (excelDate) => {
  if (typeof excelDate === "number") {
    const date = new Date((excelDate - 25569) * 86400 * 1000);
    return date?.toISOString();
  }
  return new Date(excelDate).toISOString(); // fallback
};
export function maskEmail(email) {
  if (!email) return "";

  const [name, domain] = email.split("@");

  if (name.length <= 2) return email; // too short to mask

  const first = name[0];
  const lastTwo = name.slice(-2);

  return `${first}...${lastTwo}@${domain}`;
}
export function maskPhone(num) {
  if (!num) return "";
  const str = num?.toString();
  const first = str[0];
  const lastTwo = str.slice(-2);
  const masked = "*".repeat(str.length - 3);
  return `${first}...${lastTwo}`
}

